const ORGANIC = 'organic';
const PAID_CAMPAIGN = 'paid_campaign';

export { ORGANIC, PAID_CAMPAIGN };
